module.exports = __webpack_public_path__ + "cacd347d51cac1ae1e1a10ab83c6571b.svg";